import { ApolloError } from "@apollo/client/react";
import { CancelOrSubmit } from "common/buttons";
import { MutationLoadingOrError } from "common/components/forms/MutationLoadingOrError";
import { TextField } from "common/components/forms/TextField";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";

interface FormValues {
  title: string;
}

interface Props {
  mutate(values: FormValues): Promise<boolean>;
  loading: boolean;
  error?: ApolloError;
  cancel(): void;
  complete(): void;
}

export const MultipleChoiceCreateForm: React.FC<
  React.PropsWithChildren<Props>
> = ({ mutate, loading, error, cancel, complete }) => {
  const methods = useForm<FormValues>();

  const onSubmit = async (data: FormValues) => {
    if (await mutate(data)) {
      complete();
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <TextField
          title="Tittel"
          fieldProps={methods.register("title", {
            required: "Du må fylle inn dette feltet",
          })}
        />

        <MutationLoadingOrError loading={loading} error={error} />

        <CancelOrSubmit onCancel={cancel} isLoading={loading} />
      </form>
    </FormProvider>
  );
};
